<template>
	<li v-if="isWMAEnabledPartner" class="nav-link" role="none">
		<button
			:class="officeOpenInfo.active ? 'office-open' : 'office-closed'"
			@click.prevent="onScheduleClick"
		>
			<span>{{ officeOpenInfo.indicator }}</span>
		</button>

		<schedule-panel :show="panel" @close="panel = false" />
	</li>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import SchedulePanel from '@/components/Panels/SchedulePanel.vue'

export default {
	components: {
		SchedulePanel,
	},

	computed: {
		isWMAEnabledPartner() {
			return this.partner?.wma_enabled && this.officeOpenInfo.visible
		},

		...mapGetters({
			partner: 'partners/active',
			access: 'auth/hasOfficeManagerAccess',
			clarusAppType: 'partners/clarusAppType',
		}),
		...mapState('settings', {
			officeOpenInfo: state => state.officeOpenInfo,
		}),
	},

	methods: {
		async onScheduleClick() {
			if (!this.clarusAppType) {
				return this.$alert.error(
					'Please contact your system administrator.'
				)
			}
			if (this.access) {
				if (!this.isSettingModule) {
					await this.$router.push({ name: 'app.settings' })
				}
				this.panel = true
			}
		},

		...mapActions('settings', {
			getOfficestatus: 'getOfficestatus',
		}),
	},

	name: 'OfficeStatus',

	watch: {
		$route(to) {
			this.isSettingModule = to.name === 'app.settings'
		},

		'partner.id': {
			handler(newPartnerId, oldPartnerId) {
				if (newPartnerId !== oldPartnerId) {
					this.getOfficestatus()
				}
			},
			immediate: true,
		},
	},

	created() {
		this.isSettingModule = this.$route.name === 'app.settings'
		this.getOfficestatus()
	},

	data() {
		return {
			isSettingModule: false,
			panel: false,
			intervalId: null,
		}
	},
}
</script>
